import { fontSizes, fontWeights, lineHeight } from '@ohgoodlord/design-system'
import styled from 'styled-components'
import { colors } from '../../../common/colors'

export type HighlightCalloutVariant = 'info' | 'amber'

export interface HighlightCalloutProps {
  title: string
  description: string
  variant?: HighlightCalloutVariant
}

const HighlightCalloutBox = styled.div<{ $variant?: HighlightCalloutVariant }>`
  background: ${({ $variant }) =>
    $variant === 'amber' ? colors.orangeLight : '#e6fffc'};
  border: 1px solid
    ${({ $variant }) => ($variant === 'amber' ? colors.orange : colors.primary)};
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
`

const HighlightTitle = styled.p`
  margin: 0;
  font-size: ${fontSizes.m};
  font-weight: ${fontWeights.bold};
  line-height: ${lineHeight};
  color: ${colors.greyscale1};
`

const HighlightDescription = styled.p`
  margin: 0;
  font-size: ${fontSizes.s};
  font-weight: ${fontWeights.normal};
  line-height: ${lineHeight};
  color: ${colors.greyscale2};
`

export const HighlightCallout = ({
  title,
  description,
  variant = 'info',
}: HighlightCalloutProps) => {
  return (
    <HighlightCalloutBox $variant={variant}>
      <HighlightTitle>{title}</HighlightTitle>
      <HighlightDescription>{description}</HighlightDescription>
    </HighlightCalloutBox>
  )
}
